// extracted by mini-css-extract-plugin
module.exports = {"siteTitle":"SiteTitle-module--siteTitle--lL1tx"};